export default __webpack_public_path__ + "static/media/logo-en.9009de22.svg";